var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pl-2"},[_c('span',[_vm._v(" "+_vm._s(`${_vm.$t('inspection-report.note')}: `)+" ")]),_c('span',{staticClass:"whitespace-pre-line"},[_vm._v(" "+_vm._s(_vm.notes)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }